export const API_KEY = 'AIzaSyCVsEvyYn4fyFUcy8mfue1lLtZy26swS1Q'

export const EDITING_API_KEY = 'AIzaSyByxzBta6u7yWi_1OJAL5k6nnOD3XEku-M'
